











































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import ProjectBoard from "../components/projects/project-board.vue";
import ProjectCalendar from "../components/projects/project-calendar.vue";
import MemberList from "../components/projects/member-list.vue";
import BottomNavigation from "../components/common/bottom-navigation/bottom-navigation.vue";
import BottomNavigationItem from "../components/common/bottom-navigation/bottom-navigation-item.vue";

export default Vue.extend({
  components: { ProjectBoard, ProjectCalendar, MemberList, BottomNavigation, BottomNavigationItem },
  props: {
    id: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      isCollapsed: false,
      hoverCollapseToggled: false,
      currentMenuItemName: "checklists",
      lastTab: "checklists",
      currentTab: "checklists",
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111-111-1111,
    };
  },
  computed: {
    ...mapState("project", ["loading", "currentProject"]),
    ...mapState("session", ["user"]),
    menuitemClasses: function () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  watch: {
    user(newValue) {
      if (newValue) {
        (this as any).selectedMemberId = newValue.id;
 
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    handleMenuSelect(name) {
      this.currentMenuItemName = name;
      //this.$store.dispatch("goal/setActiveMenu", name);
    },
    load() {
      let context = this as any;
    },
  },
});
